export default "/images/38e3addff2a8a0a4fcf480862e9d9a07.png";